exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app_content[data-v-4a4af583]{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;background-color:var(--black)}.content[data-v-4a4af583]{width:800px;max-width:95%;height:auto;padding:4em;border:1px solid #fff;background-color:#fff}.back[data-v-4a4af583]{text-align:right}.back a[data-v-4a4af583]{color:var(--blue);text-decoration:underline}", ""]);

// exports
